function initAccountModal() {
    var detailsModal = document.querySelector('.header__account');
    if (!detailsModal) return;

    var container = detailsModal.querySelector('.account-modal');
    if (!container || !container.querySelector) return;
    var root = container.querySelector('.account-modal__content');

    function show(panel) {
        root.querySelectorAll('.account-modal__panel').forEach(function (el) {
            if (el.getAttribute('data-panel') === panel) {
                el.removeAttribute('hidden');
            } else {
                el.setAttribute('hidden', '');
            }
        });
    }

    // 重置表单函数
    function resetAllForms() {
        var forms = root.querySelectorAll('form');
        forms.forEach(function (form) {
            form.reset();
            // 清除错误信息
            var errorBox = form.querySelector('.account-modal__errors');
            if (errorBox) {
                errorBox.classList.remove('show');
                errorBox.innerHTML = '';
            }
            // 移除按钮的loading状态
            var submitBtn = form.querySelector('button.button');
            if (submitBtn) {
                submitBtn.classList.remove('btn--loading');
            }
        });

        // 重置hCaptcha实例以避免频繁请求问题
        if (window.hcaptcha && window.__accountHcaptchaId) {
            try {
                hcaptcha.reset(window.__accountHcaptchaId);
            } catch (err) {
                // hCaptcha reset failed
            }
        }

        // 重置到默认的登录面板
        show('welcome');
    }

    detailsModal.addEventListener('click', function (e) {
        var target = e.target.closest('[data-switch-to]');
        if (!target) return;
        e.preventDefault();
        show(target.getAttribute('data-switch-to'));
    });

    // 监听弹窗打开事件，重置表单
    var details = detailsModal.querySelector('details');
    if (details) {
        details.addEventListener('toggle', function () {
            if (details.hasAttribute('open')) {
                // 弹窗打开时重置表单
                resetAllForms();
            }
        });
    }

    // 通过原生 POST 请求向 /account/login 提交表单以保持 Shopify h-captcha 注入
    var loginForm = root.querySelector('[data-panel="welcome"] form') || root.querySelector('form');
    if (loginForm) {
        var submitBtn = loginForm.querySelector('button.button');
        var errorBox = loginForm.querySelector('.account-modal__errors');

        // 使用显式 hCaptcha 执行的 Fetch 提交（阻止原生页面跳转）
        loginForm.addEventListener('submit', async function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (e.stopImmediatePropagation) e.stopImmediatePropagation();
            // 前端校验Email和密码
            var emailInput = loginForm.querySelector('input[name="customer[email]"]');
            var passwordInput = loginForm.querySelector('input[name="customer[password]"]');

            if (!emailInput || !emailInput.value.trim()) {
                if (errorBox) {
                    errorBox.innerHTML = '<div class="form__message"><p>Please enter your email address</p></div>';
                    errorBox.classList.add('show');
                }
                return;
            }

            // Email格式校验
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(emailInput.value.trim())) {
                if (errorBox) {
                    errorBox.innerHTML = '<div class="form__message"><p>Please enter a valid email address</p></div>';
                    errorBox.classList.add('show');
                }
                return;
            }

            if (!passwordInput || !passwordInput.value) {
                if (errorBox) {
                    errorBox.innerHTML = '<div class="form__message"><p>Please enter your password</p></div>';
                    errorBox.classList.add('show');
                }
                return;
            }

            // 密码长度校验（至少6位）
            if (passwordInput.value.length < 5) {
                if (errorBox) {
                    errorBox.innerHTML = '<div class="form__message"><p>Password must be at least 5 characters</p></div>';
                    errorBox.classList.add('show');
                }
                return;
            }

            if (submitBtn) submitBtn.classList.add('btn--loading');
            if (errorBox) { errorBox.classList.remove('show'); errorBox.innerHTML = ''; }

            try {
                var tokenInput = loginForm.querySelector('#AccountHcaptchaToken');
                var widgetHost = document.getElementById('account-hcaptcha');
                if (window.hcaptcha && widgetHost) {
                    if (!window.__accountHcaptchaId) {
                        window.__accountHcaptchaId = hcaptcha.render(widgetHost, {
                            sitekey: 'f06e6c50-85a8-45c8-87d0-21a2b65856fe',
                            size: 'invisible'
                        });
                    }
                    var token = await hcaptcha.execute(window.__accountHcaptchaId, { async: true });
                    var tokenStr = (typeof token === 'string') ? token : (token && token.response) ? token.response : '';
                    if (tokenInput) tokenInput.value = tokenStr;
                    loginForm.querySelectorAll('[name="h-captcha-response"]').forEach(function (el) { el.value = tokenStr; });
                }

                var fd = new FormData(loginForm);
                if (fd.get('h-captcha-response') && typeof fd.get('h-captcha-response') === 'object') {
                    fd.delete('h-captcha-response');
                }
                if (!fd.get('h-captcha-response') && tokenInput && tokenInput.value) {
                    fd.set('h-captcha-response', tokenInput.value);
                }
                if (!fd.get('form_type')) fd.set('form_type', 'customer_login');
                if (!fd.get('utf8')) fd.set('utf8', '✓');

                var body = new URLSearchParams();
                fd.forEach((v, k) => body.append(k, v));

                var res = await fetch('/account/login', {
                    method: 'POST',
                    headers: {
                        'Accept': 'text/html,*/*',
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    },
                    body: body.toString(),
                    credentials: 'same-origin'
                });
                var html = await res.text();
                var temp = document.createElement('div');
                temp.innerHTML = html;
                var formMessage = temp.querySelector('.form__message');
                var errors = temp.querySelector('.errors');
                if (formMessage) {
                    if (errorBox) {
                        errorBox.appendChild(formMessage.cloneNode(true));
                        errorBox.classList.add('show');
                    }
                }
                if (errors) {
                    if (errorBox) {
                        errorBox.appendChild(errors.cloneNode(true));
                        errorBox.classList.add('show');
                    }
                    if (submitBtn) submitBtn.classList.remove('btn--loading');
                    return;
                }
                if (submitBtn) submitBtn.classList.remove('btn--loading');
                var details = detailsModal.querySelector('details');
                if (details && details.hasAttribute('open')) details.removeAttribute('open');
                document.dispatchEvent(new CustomEvent('mm:customer:login'));
                // 登录成功后跳转到用户页面
                window.location.href = '/account';
            } catch (err) {
                Qmsg.error('Network error, please try again.');
                window.location.href = '/account/login';
            }
        });
    }

    function stringToElement(str) {
        const div = document.createElement('div');
        div.innerHTML = str;
        return div;
    }

    // 注册表单AJAX提交
    var registerForm = root.querySelector('[data-panel="register"] form');
    if (registerForm) {
        var registerSubmitBtn = registerForm.querySelector('button.button');
        var registerErrorBox = registerForm.querySelector('.account-modal__errors');

        registerForm.addEventListener('submit', async function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (e.stopImmediatePropagation) e.stopImmediatePropagation();

            // 前端校验注册表单
            var firstNameInput = registerForm.querySelector('input[name="customer[first_name]"]');
            var lastNameInput = registerForm.querySelector('input[name="customer[last_name]"]');
            var emailInput = registerForm.querySelector('input[name="customer[email]"]');
            var passwordInput = registerForm.querySelector('input[name="customer[password]"]');

            if (!firstNameInput || !firstNameInput.value.trim()) {
                if (registerErrorBox) {
                    registerErrorBox.innerHTML = '<div class="form__message"><p>Please enter your first name</p></div>';
                    registerErrorBox.classList.add('show');
                }
                return;
            }

            if (!lastNameInput || !lastNameInput.value.trim()) {
                if (registerErrorBox) {
                    registerErrorBox.innerHTML = '<div class="form__message"><p>Please enter your last name</p></div>';
                    registerErrorBox.classList.add('show');
                }
                return;
            }

            if (!emailInput || !emailInput.value.trim()) {
                if (registerErrorBox) {
                    registerErrorBox.innerHTML = '<div class="form__message"><p>Please enter your email address</p></div>';
                    registerErrorBox.classList.add('show');
                }
                return;
            }

            // Email格式校验
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(emailInput.value.trim())) {
                if (registerErrorBox) {
                    registerErrorBox.innerHTML = '<div class="form__message"><p>Please enter a valid email address</p></div>';
                    registerErrorBox.classList.add('show');
                }
                return;
            }

            if (!passwordInput || !passwordInput.value) {
                if (registerErrorBox) {
                    registerErrorBox.innerHTML = '<div class="form__message"><p>Please enter your password</p></div>';
                    registerErrorBox.classList.add('show');
                }
                return;
            }

            // 密码长度校验（至少5位）
            if (passwordInput.value.length < 5) {
                if (registerErrorBox) {
                    registerErrorBox.innerHTML = '<div class="form__message"><p>Password must be at least 5 characters</p></div>';
                    registerErrorBox.classList.add('show');
                }
                return;
            }

            if (registerSubmitBtn) registerSubmitBtn.classList.add('btn--loading');
            if (registerErrorBox) { registerErrorBox.classList.remove('show'); registerErrorBox.innerHTML = ''; }

            try {
                // 处理注册表单的hCaptcha
                var registerTokenInput = registerForm.querySelector('#RegisterHcaptchaToken');
                var registerWidgetHost = document.getElementById('register-hcaptcha');
                if (window.hcaptcha && registerWidgetHost) {
                    if (!window.__registerHcaptchaId) {
                        window.__registerHcaptchaId = hcaptcha.render(registerWidgetHost, {
                            sitekey: 'f06e6c50-85a8-45c8-87d0-21a2b65856fe',
                            size: 'invisible'
                        });
                    }
                    var registerToken = await hcaptcha.execute(window.__registerHcaptchaId, { async: true });
                    var registerTokenStr = (typeof registerToken === 'string') ? registerToken : (registerToken && registerToken.response) ? registerToken.response : '';
                    if (registerTokenInput) registerTokenInput.value = registerTokenStr;
                    registerForm.querySelectorAll('[name="h-captcha-response"]').forEach(function (el) { el.value = registerTokenStr; });
                }

                var fd = new FormData(registerForm);
                if (!fd.get('form_type')) fd.set('form_type', 'create_customer');
                if (!fd.get('utf8')) fd.set('utf8', '✓');
                if (!fd.get('return_to')) fd.set('return_to', '/account/register');

                var body = new URLSearchParams();
                fd.forEach((v, k) => body.append(k, v));



                var res = await fetch('/account', {
                    method: 'POST',
                    headers: {
                        'Accept': 'text/html,*/*',
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: body.toString(),
                    credentials: 'same-origin'
                });

                var html = await res.text();
                var temp = document.createElement('div');
                temp.innerHTML = html;
                var formMessage = temp.querySelector('.form__message');
                var errors = temp.querySelector('.errors') || temp.querySelector('#create_customer ul li');
                debugger
                if (formMessage) {
                    if (registerErrorBox) {
                        registerErrorBox.appendChild(formMessage.cloneNode(true));
                    }
                }
                if (errors) {
                    if (registerErrorBox) {
                        registerErrorBox.appendChild(stringToElement(errors.innerText));
                        registerErrorBox.classList.add('show');
                    }
                    if (registerSubmitBtn) registerSubmitBtn.classList.remove('btn--loading');
                    return;
                }

                // 注册成功，进行自动登录
                document.dispatchEvent(new CustomEvent('mm:customer:register'));
                window.location.href = '/account';

                // 自动登录
                // try {
                //     var loginData = new URLSearchParams();
                //     loginData.append('form_type', 'customer_login');
                //     loginData.append('utf8', '✓');
                //     loginData.append('customer[email]', emailInput.value);
                //     loginData.append('customer[password]', passwordInput.value);
                //     loginData.append('return_to', '/');

                //     // 为自动登录获取新的hCaptcha token
                //     if (window.hcaptcha && registerWidgetHost) {
                //         var autoLoginToken = await hcaptcha.execute(window.__registerHcaptchaId, { async: true });
                //         var autoLoginTokenStr = (typeof autoLoginToken === 'string') ? autoLoginToken : (autoLoginToken && autoLoginToken.response) ? autoLoginToken.response : '';
                //         if (autoLoginTokenStr) {
                //             loginData.append('h-captcha-response', autoLoginTokenStr);
                //         }
                //     }

                //     var loginRes = await fetch('/account/login', {
                //         method: 'POST',
                //         headers: {
                //             'Accept': 'text/html,*/*',
                //             'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                //             'X-Requested-With': 'XMLHttpRequest'
                //         },
                //         body: loginData.toString(),
                //         credentials: 'same-origin'
                //     });

                //     var loginHtml = await loginRes.text();
                //     var loginTemp = document.createElement('div');
                //     loginTemp.innerHTML = loginHtml;
                //     var loginErrors = loginTemp.querySelector('.form__message, .errors');

                //     if (!loginErrors) {
                //         // 登录成功，关闭弹窗并跳转到首页
                //         if (registerSubmitBtn) registerSubmitBtn.classList.remove('btn--loading');
                //         var details = detailsModal.querySelector('details');
                //         if (details && details.hasAttribute('open')) details.removeAttribute('open');
                //         window.location.href = '/account';
                //     } else {
                //         // 登录失败，显示提示但不阻止用户
                //         // Auto login failed after registration
                //         if (registerSubmitBtn) registerSubmitBtn.classList.remove('btn--loading');
                //         var details = detailsModal.querySelector('details');
                //         if (details && details.hasAttribute('open')) details.removeAttribute('open');
                //         window.location.href = '/';
                //     }
                // } catch (autoLoginErr) {
                //     // 自动登录失败，直接跳转到首页
                //     // Auto login error
                //     if (registerSubmitBtn) registerSubmitBtn.classList.remove('btn--loading');
                //     var details = detailsModal.querySelector('details');
                //     if (details && details.hasAttribute('open')) details.removeAttribute('open');
                //     window.location.href = '/';
                // }

            } catch (err) {
                if (registerErrorBox) { registerErrorBox.textContent = '网络错误，请重试。'; registerErrorBox.classList.add('show'); }
                if (registerSubmitBtn) registerSubmitBtn.classList.remove('btn--loading');
            }
        });
    }

    // 重置密码表单AJAX提交
    var recoverForm = root.querySelector('[data-panel="recover"] form');
    if (recoverForm) {
        var recoverSubmitBtn = recoverForm.querySelector('button.button');
        var recoverErrorBox = recoverForm.querySelector('.account-modal__errors');

        recoverForm.addEventListener('submit', async function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (e.stopImmediatePropagation) e.stopImmediatePropagation();

            // 前端校验重置密码表单
            var emailInput = recoverForm.querySelector('input[name="email"]');

            if (!emailInput || !emailInput.value.trim()) {
                if (recoverErrorBox) {
                    recoverErrorBox.innerHTML = '<div class="form__message"><p>Please enter your email address</p></div>';
                    recoverErrorBox.classList.add('show');
                }
                return;
            }

            // Email格式校验
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(emailInput.value.trim())) {
                if (recoverErrorBox) {
                    recoverErrorBox.innerHTML = '<div class="form__message"><p>Please enter a valid email address</p></div>';
                    recoverErrorBox.classList.add('show');
                }
                return;
            }

            if (recoverSubmitBtn) recoverSubmitBtn.classList.add('btn--loading');
            if (recoverErrorBox) { recoverErrorBox.classList.remove('show'); recoverErrorBox.innerHTML = ''; }

            try {
                // 确保hCaptcha实例存在并获取token
                var recoverTokenInput = recoverForm.querySelector('#RecoverHcaptchaToken');
                var loginWidgetHost = document.getElementById('account-hcaptcha');
                if (window.hcaptcha && loginWidgetHost) {
                    try {
                        // 如果登录的hCaptcha实例不存在，则创建它
                        if (!window.__accountHcaptchaId) {

                            window.__accountHcaptchaId = hcaptcha.render(loginWidgetHost, {
                                sitekey: 'f06e6c50-85a8-45c8-87d0-21a2b65856fe',
                                size: 'invisible'
                            });
                        }

                        // 添加延迟以避免频繁请求
                        await new Promise(resolve => setTimeout(resolve, 1000));


                        var recoverToken = await hcaptcha.execute(window.__accountHcaptchaId, { async: true });

                        var recoverTokenStr = (typeof recoverToken === 'string') ? recoverToken : (recoverToken && recoverToken.response) ? recoverToken.response : '';

                        if (recoverTokenInput) recoverTokenInput.value = recoverTokenStr;
                        recoverForm.querySelectorAll('[name="h-captcha-response"]').forEach(function (el) { el.value = recoverTokenStr; });
                    } catch (hcaptchaErr) {
                        // Recover hCaptcha error
                        // 继续执行但不包含hCaptcha token
                    }
                }

                var fd = new FormData(recoverForm);
                if (!fd.get('form_type')) fd.set('form_type', 'recover_customer_password');
                if (!fd.get('utf8')) fd.set('utf8', '✓');

                var body = new URLSearchParams();
                fd.forEach((v, k) => body.append(k, v));

                // 调试：输出发送的参数


                var res = await fetch('/account/recover', {
                    method: 'POST',
                    headers: {
                        'Accept': 'text/html,*/*',
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: body.toString(),
                    credentials: 'same-origin'
                });

                var html = await res.text();
                var temp = document.createElement('div');
                temp.innerHTML = html;
                var formMessage = temp.querySelector('.form__message');
                var errors = temp.querySelector('.errors');

                if (formMessage) {
                    if (recoverErrorBox) {
                        recoverErrorBox.appendChild(formMessage.cloneNode(true));
                        recoverErrorBox.classList.add('show');
                    }
                }
                if (errors) {
                    if (recoverErrorBox) {
                        recoverErrorBox.appendChild(errors.cloneNode(true));
                        recoverErrorBox.classList.add('show');
                    }
                    if (recoverSubmitBtn) recoverSubmitBtn.classList.remove('btn--loading');
                    return;
                }

                // 重置密码请求成功，显示成功消息
                if (recoverSubmitBtn) recoverSubmitBtn.classList.remove('btn--loading');
                if (recoverErrorBox) {
                    recoverErrorBox.innerHTML = '<div class="form__message form__message--success"><p>Password reset email has been sent to your email address</p></div>';
                    recoverErrorBox.classList.add('show');
                }

                // 3秒后自动切换回登录面板
                // setTimeout(function () {
                //     show('welcome');
                // }, 3000);

            } catch (err) {
                if (recoverErrorBox) { recoverErrorBox.textContent = '网络错误，请重试。'; recoverErrorBox.classList.add('show'); }
                if (recoverSubmitBtn) recoverSubmitBtn.classList.remove('btn--loading');
            }
        });
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccountModal);
} else {
    initAccountModal();
}